// =====================================
// LandingPage.jsx
// Wrapper for modular landing page
// =====================================

import { Box } from "@mui/material";
import { Helmet } from "react-helmet";
import { Footer } from "../components/Footer";

import LandingHero from "../sections/landing/LandingHero";
import LandingSocial from "../sections/landing/LandingSocial";
import PageContainer from "../components/PageContainer";
export default function LandingPage() {
  return (
   <PageContainer>
    <Box sx={{ bgcolor: "#f7f9fc", minHeight: "100vh" }}>
      {/* SEO */}
      <Helmet>
        <title>CBT Nova – Free WAEC, JAMB & NECO CBT Practice</title>
        <meta
          name="description"
          content="Practice real WAEC, JAMB and NECO CBT questions online with instant scoring, analytics and real exam simulation."
        />
      </Helmet>

      {/* HERO SECTION */}
      <LandingHero />

      {/* SOCIAL / BLOG / FAQ SECTION */}
      <LandingSocial />



      {/* FOOTER */}
      <Footer />
    </Box>
	  </PageContainer>
	
  );
}
